(() => {
  const DAY = 24 * 60 * 60 * 1000;

  function initPopup(popup) {
    if (!popup || popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    const mode = popup.dataset.mode || 'disabled';
    if (mode === 'disabled') return;

    const storageKey = `q974-popup-${popup.id}`;
    const delay = Math.max(0, Number(popup.dataset.delay || 0)) * 1000;
    const frequency = Math.max(1, Number(popup.dataset.frequency || 14)) * DAY;
    const lastClosed = Number(localStorage.getItem(storageKey) || 0);
    const canShow = mode === 'testing' || Date.now() - lastClosed >= frequency;
    if (!canShow) return;

    let previousFocus = null;

    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const open = () => {
      previousFocus = document.activeElement;
      popup.hidden = false;
      document.body.classList.add('q974-popup-open');
      const firstFocusable = popup.querySelector(focusableSelector);
      window.requestAnimationFrame(() => firstFocusable?.focus());
    };

    const close = () => {
      popup.hidden = true;
      document.body.classList.remove('q974-popup-open');
      if (mode !== 'testing') localStorage.setItem(storageKey, String(Date.now()));
      previousFocus?.focus?.();
    };

    popup.querySelectorAll('[data-q974-popup-close]').forEach((button) => button.addEventListener('click', close));

    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = [...popup.querySelectorAll(focusableSelector)].filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.setTimeout(open, Shopify.designMode ? 250 : delay);
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-q974-popup]').forEach(initPopup);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
